module.exports = __webpack_public_path__ + "static/media/testimonial-5.6471a7d3.jpg";